

<lcp-header [isInverted]="true"></lcp-header>

<ng-container *ngIf="fields">
  <section class="home-hero-section"
    [style.background-image]="'url(' + bannerImage + ')'">
    
    <div class="home-hero-section-shroud">
    </div>

    <div class="flex-10a" ></div>
    <div class="home-hero-section-content-container" >
      <div class="home-hero-section-content-container-inner" >
        <div class="home-hero-section-content" >
          <div class="flex-10a"></div>
          <div class="home-tagline-container">
            <div class="flex-10a"></div>
            <div>
              <h3 #heroMessageLine1
                class="home-tagline home-tagline--lowercase line-1"
                [class.should-display-cursor]="shouldDisplayTagline[0]"></h3>  
            </div>
            <div>
              <h1 #heroMessageLine2
                class="home-tagline line-2"
                [class.home-tagline--uppercase]="taglineUppercase"
                [class.home-tagline--lowercase]="taglineLowercase"
                [class.should-display-cursor]="shouldDisplayTagline[1]"></h1>  
            </div>
          </div>
          <div class="home-hero-subheading-container"
            [innerHtml]="lcpHelper.htmlFromRichText(fields['subheading'])">
          </div>
        </div>
        <div class="flex-10a"></div>
      </div>
    </div>
  </section>
  
  <section class="home-section" *ngFor="let section of fields['sections']"
    [ngClass]="'lcp-' + section.fields['slug']"
    [class.is-inverted]="section.fields['inverted']">
    <div class="home-section-content">

      <h2 class="home-section-title">
        {{ section.fields['title'] }}
      </h2>
    
      <div class="home-section-main-content">

        <ng-container *ngIf="section.fields['slug'] == 'home-services'">
          <ng-content *ngTemplateOutlet="servicesSection; context:{ section: section }"></ng-content>
        </ng-container>

        <ng-container *ngIf="section.fields['slug'] == 'home-approach'">
          <ng-content *ngTemplateOutlet="approachSection; context:{ section: section }"></ng-content>
        </ng-container>

        <ng-container *ngIf="section.fields['slug'] == 'home-clients'">
          <ng-content *ngTemplateOutlet="clientsSection; context:{ section: section }"></ng-content>
        </ng-container>

        <ng-container *ngIf="['home-services','home-approach','home-clients'].indexOf(section.fields['slug']) < 0">
          <code>FORMATTING NEEDED: {{ section.fields['slug'] }}</code>
        </ng-container>
    
      </div>
    </div>
  </section>  
</ng-container>

<!-- <lcp-footer></lcp-footer> -->


<ng-template>

</ng-template>

<ng-template #servicesSection let-section="section">

  <div class="home-services-tabs">
    <ng-container *ngFor="let content of section.fields['items']; index as contentIndex">
      <div class="home-services-tab-container" *ngIf="content.fields['media'] || content.fields['title']" >
        
        <div class="home-services-tab"
        (click)="handleSelectService($event, content)"
        [class.is-active]="serviceActive == content.fields['slug'] || (!serviceActive && contentIndex == 0)">

          <ng-container *ngIf="content.fields['media']" >
            <ng-container *ngFor="let media of content.fields['media']; index as mediaIndex">
              <div class="home-services-icon-container">
                <img class="home-services-icon" [src]="media.fields['file'].url">
              </div>

              <div #lottiePlayerContainer
                [ngClass]="['lottie-player-container', 'lottie-player-container_' + contentIndex + '_' + mediaIndex]"
                *ngIf="media.fields['file'] && media.fields['file']['contentType'] === 'application/json'">

                <lottie-player #lottiePlayer
                  [ngClass]="['lottie-player', 'lottie-player_' + contentIndex + '_' + mediaIndex]"
                  [src]="'https://' + media.fields['file'].url"
                  (ready)="handlePlayerReady($event, contentIndex + '_' + mediaIndex)"
                  (load)="handlePlayerLoad($event)">
                </lottie-player>
                <!-- style="width: 400px; height: 100vh;" -->
              </div>
            </ng-container>
          </ng-container>

          <div class="home-services-tab-title-container">
            <h4 *ngIf="content.fields['title']" class="home-block-title">
              {{ content.fields['title'] }}
            </h4>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div #homeServicesTabContent class="home-section-tab-content"
    [innerHtml]="lcpHelper.htmlFromRichText(section.fields['items'][0].fields['body'])">
  </div>
</ng-template>


<ng-template #approachSection let-section="section">
  <div class="home-section-approach-content-container" *ngFor="let content of section.fields['items']; index as contentIndex">
    <div *ngIf="content.fields['media']" 
      class="home-section-content-media-container">

      <div *ngFor="let media of content.fields['media']; index as mediaIndex">
        <div #lottiePlayerContainer
          [ngClass]="['lottie-player-container', 'lottie-player-container_' + contentIndex + '_' + mediaIndex]"
          *ngIf="media.fields['file'] && media.fields['file']['contentType'] === 'application/json'">

          <lottie-player #lottiePlayer
            [ngClass]="['lottie-player', 'lottie-player_' + contentIndex + '_' + mediaIndex]"
            [src]="'https://' + media.fields['file'].url"
            (ready)="handlePlayerReady($event, contentIndex + '_' + mediaIndex)"
            (load)="handlePlayerLoad($event)">
          </lottie-player>
          <!-- style="width: 400px; height: 100vh;" -->
        </div>
      </div>
    </div>

    <div class="home-approach-content">
      <div class="home-block-title-container">
        <h4 *ngIf="content.fields['title']" class="home-block-title">
          {{ content.fields['title'] }}
        </h4>
      </div>

      <div *ngIf="content.fields['body']" 
        class="home-section-content-body"
        [innerHtml]="lcpHelper.htmlFromRichText(content.fields['body'])">
      </div>
    </div>
  </div>
</ng-template>


<ng-template #clientsSection let-section="section">
  <div class="home-section-content-container" *ngFor="let content of section.fields['items']; index as contentIndex">
    <div *ngIf="content.fields['media']" 
      class="home-section-content-media-container">

      <div *ngFor="let media of content.fields['media']; index as mediaIndex">
        <div #lottiePlayerContainer
          [ngClass]="['lottie-player-container', 'lottie-player-container_' + contentIndex + '_' + mediaIndex]"
          *ngIf="media.fields['file'] && media.fields['file']['contentType'] === 'application/json'">

          <lottie-player #lottiePlayer
            [ngClass]="['lottie-player', 'lottie-player_' + contentIndex + '_' + mediaIndex]"
            [src]="'https://' + media.fields['file'].url"
            (ready)="handlePlayerReady($event, contentIndex + '_' + mediaIndex)"
            (load)="handlePlayerLoad($event)">
          </lottie-player>
          <!-- style="width: 400px; height: 100vh;" -->
        </div>
      </div>
    </div>

    <div class="home-block-title-container">
      <h4 *ngIf="content.fields['title']" class="home-block-title">
        {{ content.fields['title'] }}
      </h4>
    </div>

    <div *ngIf="content.fields['body']" 
      class="home-section-content-body"
      [innerHtml]="lcpHelper.htmlFromRichText(content.fields['body'])">
    </div>
  </div>
</ng-template>